<template>
  <div class="height-all refer-music-list">
    <div class="refer-music-list-box height-all">
      <QueryEmptyRetry
        :loading="renderData.initLoading"
        v-if="renderData.loadError || renderData.initLoading"
        @retry="
          () => {
            doRetry(true);
          }
        "
      ></QueryEmptyRetry>
      <PullTo
        itemIdField="id"
        v-else
        :datas="renderData.referDatas"
        v-model:refreshing="renderData.refreshing"
        v-model:loadingMore="renderData.loadingMore"
        v-model:isLoading="renderData.isLoading"
        v-model:finished="renderData.finished"
        @refresh="doRefresh"
        @loadMore="doLoadMore"
      >
        <template v-slot:default="slotProps">
          <div class="refer-music-item">
            <ReferMusicItem
              audioUrlSuffix="?type=refer_list_tab=2"
              :hideFrom="true"
              :item="slotProps.item"
              :index="slotProps.index"
              :tabCode="3"
              @apply="doApply"
              @cancel="doCancel"
              @more="doMore"
              @editSongTitle="doEditSongTitle"
              @delete="doDelete"
            ></ReferMusicItem>
          </div>
        </template>
      </PullTo>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
} from "vue";
import QueryEmptyRetry from "@/components/basic/pullTo/queryEmptyRetry.vue";
import PullTo from "@/components/basic/pullTo/PullTo.vue";
import { EmotionalLabelData } from "@/config/const.js";
import { useRouter, useRoute } from "vue-router";
import ReferMusicItem from "./referenceItem.vue";
import userReferMusicStore from "@/store/create/referMusicStore.js";
import useUserDataStore from "@/store/userDataStore.js";

const userDataStore = useUserDataStore();

const referMusicStore = userReferMusicStore();
const getFilterOptions = () => {
  return [
    {
      cn: "",
      en: "emotionalLabel",
      children: EmotionalLabelData.list,
    },
  ];
};
const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router;
const route = useRoute();

const props = defineProps({
  isCurShow: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits([
  "apply",
  "cancel",
  "more",
  "editSongTitle",
  "delete",
]);
const renderData = reactive({
  filterValue: null,
  // {
  //   en: 'relaxing',
  //   cn: '放松',
  // },
  referDatas: [],
  refreshing: false,
  loadingMore: false,
  isLoading: false,
  loadError: false,
  finished: false,
  initLoading: false,
});
const doRefresh = (done, errodone) => {
  renderData.isLoading = true;
  referMusicStore.refresh(
    getQueryParams(),
    (...args) => {
      renderData.finished = args[1] ?? true;
      renderData.isLoading = false;
      renderData.loadError = false;
      done(...args);
    },
    (...args) => {
      renderData.isLoading = false;
      renderData.loadError = true;
      errodone(...args);
    }
  );
};

const doLoadMore = (done, errodone) => {
  renderData.isLoading = true;
  referMusicStore.loadMore(
    getQueryParams(),
    (...args) => {
      renderData.finished = args[1] ?? true;
      renderData.isLoading = false;
      done(...args);
    },
    (...args) => {
      renderData.isLoading = false;
      errodone(...args);
    }
  );
};

const doRetry = (isRetry) => {
  if (!isRetry) {
    renderData.initLoading = true;
  }
  renderData.isLoading = true;
  referMusicStore.init(
    getQueryParams(),
    (...args) => {
      renderData.isLoading = false;
      renderData.finished = args[1] ?? true;
      renderData.loadError = false;
      renderData.initLoading = false;
    },
    (...args) => {
      renderData.isLoading = false;
      renderData.loadError = true;
      renderData.initLoading = false;
    }
  ),
    undefined,
    isRetry;
};

const getQueryParams = () => {
  return {
    query_type: 3,
  };
};

const doApply = (item) => {
  emits("apply", item, 3);
};

const doCancel = (item) => {
  emits("cancel", item, 3);
};

const doMore = (item) => {
  emits("more", item, 3);
};

const doEditSongTitle = (item) => {
  emits("editSongTitle", item, 3);
};

const doDelete = (item) => {
  emits("delete", item, 3);
};

watch(
  () => referMusicStore.datas_upload,
  (newVal, oldVal) => {
    renderData.referDatas = referMusicStore.datas_upload;
  }
);

watch(
  () => props.isCurShow,
  (newVal, oldVal) => {
    if (
      props.isCurShow &&
      !referMusicStore[
        `hasInit_${referMusicStore.TabDataSuffixMap[getQueryParams().query_type]}`
      ]
    ) {
      doRetry();
    }
  }
);

const init = () => {
  if (referMusicStore.datas_upload?.length) {
    renderData.referDatas = referMusicStore.datas_upload;
    renderData.initLoading = false;
  } else {
    if (userDataStore.isLogin) {
      doRetry();
    } else {
      renderData.initLoading = false;
      renderData.finished = true;
    }
  }
};

onMounted(() => {
  init();
});
</script>
<style lang="scss">
.refer-music-list {
  .refer-music-list-main {
    flex-direction: column;
  }
  .refer-music-list-box {
  }
}
</style>
